import { render, staticRenderFns } from "./AcademicProgressInformResultRow.vue?vue&type=template&id=e1645c84&scoped=true&"
import script from "./AcademicProgressInformResultRow.vue?vue&type=script&lang=js&"
export * from "./AcademicProgressInformResultRow.vue?vue&type=script&lang=js&"
import style0 from "./AcademicProgressInformResultRow.vue?vue&type=style&index=0&id=e1645c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1645c84",
  null
  
)

export default component.exports